import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle<{ mobile: boolean }>`
  :root {
    --main-color: #42434b;
    --gray-1: #e5e5ea;
    --gray-2: #e0e0e0;
    --gray-3: #9e9e9e;
    --gray-4: #d9d9d9;
    --gray-5: #bdbdbd;
    --gray-6: #757575;
    --gray-7: #616161;
    --gray-8: #424242;
    --gray-9: #212121;
    --main-orange: #f1b75a;
    --orange-2: #f4c373;
    --orange-3: #ffefd6;
    --green: #4caf50;
    --success-green: #67C23A;
    --bright-green: #00BA28;
    --red: #f44336;
    --darkred: #ff0000;
    --white: #fff;
    --ghostwhite: #FAFAFA;
    --slightly-sky-blue: #F8F8F8;
    --black: #000;
    --yellow: #FFC620;
    --status-green: #97FDE3;
    --status-border-green: #78D1BB;
    --status-light-green: #d9f6da;
    --status-border-light-green: #64d56a;
    --status-violet: #BEC9FF;
    --status-border-violet: #A1AAD8;
    --status-red: #FFCECA;
    --status-pink: #FF99CC;
    --status-border-pink: #FF6699;
    --status-border-red: #FFA199;
    --purple: #d8acec;
    --animate: 250ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  .Toastify__toast-container {
    margin-top: ${(props) => props.mobile ? '20px;' : '0px;'};
    min-width: 350px;
    max-width: 400px;
    width: ${(props) => props.mobile ? '95%' : ''};
    margin: 0px auto;
    right: ${(props) => props.mobile ? '0' : '20px;'};
    top: 20px;
  }

  .Toastify__toast { 
    border-radius: 15px;
    border: 2px solid var(--main-orange);
    min-width: 350px;  
    max-width: 400px;
  }

  .Toastify__toast-body {
    padding: 0;
  }

  .Toastify__close-button {
    display: none;
  }

  .Toastify__progress-bar--wrp {
    visibility: hidden;
  }

  div#root {
    width: 100%;
    height: auto;
  }
  * {
    color: var(--main-color);
    box-sizing: border-box;
    font-size: 14px;
    padding: 0;
    margin: 0;
  }
  body {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 400;
    padding: 0;
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #fff;
  }
  ::-webkit-scrollbar {
    width: 4px;
    background: transparent;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
    width: 10px;
    -webkit-border-radius: 0px;
    border-radius: 0px;
  }
  ::-webkit-scrollbar-thumb {
    width: 4px;
    -webkit-border-radius: 5px;
    border-radius: 8px;
    background: var(--main-orange);
  }
  ::-webkit-scrollbar:horizontal {
    height: 4px;
  }

  input, textarea {
    border: 1px solid var(--gray-2);
    border-radius: 8px;
  }
  input:is(:hover, :focus), textarea:is(:hover, :focus) {
    border: 1px solid var(--gray-2);
    outline: none;
  }

  input[type=checkbox] {
    display: grid;
    place-content: center;
    appearance: none;
    background-color: var(--white);
    font: inherit;
    color: var(--white);
    width: 16px;
    height: 16px;
    border: 2px solid var(--main-color);
    border-radius: 3px;
  }

  input[type="checkbox"]::before {
    content: "";
    width: 7px;
    height: 7px;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--form-control-color);
    transform-origin: bottom left;
    border: 1px solid var(--white);
    background-color: var(--white);

    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  }
  
  input[type="checkbox"]:checked::before {
    transform: scale(1);
  }

  input[type="checkbox"]:checked {
    background-color: var(--main-orange);
    border: 2px solid var(--main-orange);
  }

  input[type="checkbox"]:disabled {
    --form-control-color: var(--form-control-disabled);
  
    color: var(--gray-2);
    cursor: not-allowed;
  }

  textarea::-webkit-scrollbar {
    width: 4px;
    background: transparent;
  }
  textarea::-webkit-scrollbar-track {
    background: transparent;
    width: 4px;
    -webkit-border-radius: 0px;
    border-radius: 0px;
  }
  textarea::-webkit-scrollbar-thumb {
    width: 4px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    background: var(--main-orange);
  }

  select::-webkit-scrollbar {
    width: 4px;
    background: transparent;
  }
  select::-webkit-scrollbar-track {
    background: transparent;
    width: 4px;
    -webkit-border-radius: 0px;
    border-radius: 0px;
  }
  select::-webkit-scrollbar-thumb {
    width: 4px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    background: var(--main-orange);
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
    input[type='number'] {
    -moz-appearance:textfield;
  }
  button {
    font-family: 'Inter', sans-serif;
    border-radius: 8px;
    border: none;
    outline: none;
    cursor: pointer;
    &:is(:hover, :focus) {
      color: var(--main-orange);
    }
  }
  h1,
  h2,
  h3,
  h4,
  p {
    margin-top: 0;
    margin-bottom: 0;
  }
  h1,
  h2,
  h3,
  h4 {
    font-weight: 600;
    line-height: 1.2;
  }
  ol,
  ul {
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 0;
    list-style: none;
  }
  html,
  body {
    height: auto;
    width: 100%;
  }
  a {
    color: inherit;
    text-decoration: none;
    font-size: inherit;
  }
  img {
    display: block;
  }

  .container-paginate {
    display: flex;
    align-items: center;
    gap: 4px;
    align-self: flex-end;
    margin-top: 32px;
  }
  .paginate {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    font-size: 16px;
    line-height: 1.5;
    padding: 4px;
    color: var(--gray-6);
    border-radius: 8px;
    transition: all var(--animate);
  }
  .paginate-page-link-element {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .paginate:is(:hover, :focus){
    color: var(--white);
    background-color: var(--main-orange);
  }
  .active-paginate {
    color: var(--white);
    background-color: var(--main-orange);
  }
  .next-prev-paginate {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    font-size: 16px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    border-radius: 8px;
    color: var(--gray-6);
    transition: all var(--animate);
  }
  .next-prev-paginate:is(:hover, :focus) {
    color: var(--white);
    background-color: var(--main-orange);
  }

    .react-select {
      border: none;
      
      &::-webkit-scrollbar {
        width: 4px;
        background: transparent;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
        width: 4px;
        -webkit-border-radius: 0px;
        border-radius: 0px;
      }
      &::-webkit-scrollbar-thumb {
        width: 4px;
        -webkit-border-radius: 5px;
        border-radius: 5px;
        background: var(--main-orange);
      }

      &:hover {
       border: none;
      }
    }

  .action-modal-role-dialog {
    max-width: 1300px;
  }

  .modal.modal-static .modal-dialog {
    transform: scale(1);
  }

  .modal-news-item-dialog {
    max-width: 624px;
  }

  .modal-catalog-stock-report {
    max-width: 370px;
  }

  .modal-title.action-modal-role, .modal-title.modal-create-news-item {
    text-align: center;
    margin-bottom: 10px;
    font-weight: 700;
  } 

  .modal-content {
    border-radius: 15px;
    border: none;
  }

  .modal-form-content {
    padding: 20px;
  }

  .modal-body {
    padding-top: 0px;
  }

  .modal-body.product-set-export-horoshop-modal-body {
    padding: 0px 35px 15px 35px;
  }

  .modal-body.edit-brand-modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .modal-body.modal-news-read-more-body {
    @media screen and (max-height: 500px) {
      max-height: 250px;
    }
  }

  .modal-body.modal-catalog-prices-materials-body {
    max-height: 425px;
    padding: 20px 5px 0px 5px;
  }

  .horoshop-product-set-export-modal {
    max-width: 755px;

    button.btn-action {
      font-size: 14px;
      font-weight: 500;
      width: 200px;
      padding: 12px 12px;
      display: inline-flex;
      margin-right: 30px;
    }
  }

  .catalog-prices-modal-dialog {
    max-width: 1200px;
  }

  .catalog-prices-modal-price-variation-dialog {
    @media screen and (min-width: 769px) {
      max-width: 620px;
    }
  }

  .modal-body.catalog-prices-modal-price-variation-body {
    padding: 0px 0px 40px 0px;
  }

  .catalog-prices-modal-price-materials-dialog {
    @media screen and (min-width: 769px) {
      max-width: 580px;
    }
  }

  .modal-body.catalog-prices-modal-body {
    position: relative;
    padding: 0px 15px 15px 15px;

    @media screen and (max-width: 768px) {
      padding: 0px 7px 7px 7px;
    }
  }

  .price-generator-history-modal-dialog {
    max-width: 1000px;
  }

  .availability-in-stock-modal-dialog {
    max-width: 1308px;
    
    @media (max-width: 1307.99px) {
      margin: 10px;
      max-width: calc(100% - 10px);
    }
  }

  .availability-in-stock-modal-dialog-short {
    max-width: 1170px;
  }

  .modal-body.availability-in-stock-modal-body {
    @media (min-width: 1307.99px) {
      margin: 0px 33px 10px 24px;
    }
  }

  .modal-body.price-generator-history-modal-body {
    max-height: 400px;
    padding-bottom: 30px;
    padding-left: 20px;
    padding-right: 20px;

    @media screen and (max-width: 768px) {
      padding-left: 0px;
      padding-right: 0px;
    }

    .col.separated {
      padding-bottom: 0px;
      margin-bottom: 0px;
      border-right: 1px solid var(--gray-2);
      border-bottom: none;

      @media screen and (max-width: 991px) {
        border-right: none;
        border-bottom: 1px solid var(--gray-2);
        padding-bottom: 30px;
        margin-bottom: 20px;
      }
    }
  }

  .modal-news-read-more-dialog .modal-content {
    max-height: 300px;

    @media screen and (min-width: 1200px) {
      max-height: 700px;
    }
  }

  .modal-catalog-crm-info-dialog {
    @media screen and (min-width: 768px) {
      max-width: 80%;
    }
  }

  .modal-body.modal-catalog-crm-info-body {
    min-height: 200px;
  }

  .slider-modal-dialog-view {
    max-width: 955px;

    & div.photos-column {
      position: relative;
    }

    & .slider-view-header {
      margin-left: auto;
    }

    & input#slider-view-original-switcher {
      width: 40px;
      height: 20px;
      border: 2px solid var(--main-orange);
      margin-bottom: 3px;
    }

    & input#slider-view-original-switcher::before {
      transform: scale(0);
    }

    & input#slider-view-original-switcher:focus {
      box-shadow: none;
    }

    & input#slider-view-original-switcher:active {
      filter: none;
    }
  }

  .slider-modal-dialog-view.no-menu {
    max-width: 600px;
  }

  .slider-modal-dialog-edit {
    max-width: 1255px;

    & div.menu-column {
      margin-top: ${(props) => props.mobile ? '30px;' : '0px;'};
      border-top: ${(props) => props.mobile ? '1px solid var(--gray-2);' : 'none;'};
      border-left: ${(props) => props.mobile ? 'none;' : '1px solid var(--gray-2);'};
      max-height: 580px;
      overflow-y: auto;
    }

    & div.photos-column {
      position: relative;
    }
  }

  .slider-modal-dialog-edit.short-menu {
    max-width: 955px;
  }

  .slider-modal-dialog-edit.no-menu {
    max-width: 600px;
  }

  .marketplace-modal-dialog {
    max-width: 80%;

    & .row {
      margin: 15px 0px;
    }

    & .row.row-title {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    & .col.materialColors {
      max-width: 200px;
      margin: 0px 15px;
    }

    & .col.materialName {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0px;
      max-width: 200px;
    }

    & .modal-header {
      padding: 20px;
    }

    @media screen and (max-width: 768px) {
      max-width: 100%;
    }
  }

  .horoshop-export-modal, .epicentr-export-modal {
    max-width: 80%;

    & .btn-close {
      padding-right: 30px;
    }

    & .modal-header, & .modal-body {
      padding-left: 40px;
    }

    & .modal-body {
      padding-right: 40px;
    }

    & .col {
      padding-left: 0px;
      padding-right: 30px;
    }

    & .col.short {
      max-width: 150px;
    }

    & .col.normal {
      max-width: 400px;
    }

    & .col.wide {
      max-width: 700px;
    }

    & .row {
      padding-top: 10px;
      padding-bottom: 30px;
    }

    & .select-form-group > div {
      margin-top: 0px;
    }

    & .categories-select {
      margin-bottom: 15px;
    }

    & .quantity-field {
      margin-top: 15px;
    }
  }

  .article-mats-modal-dialog {
    max-width: 400px;
  }

  .modal-news-read-more-dialog {
    max-width: 444px;

    @media screen and (min-width: 1200px) {
      max-width: 700px;
      max-height: 700px;
    }
  }

  .modal-header.read-news-modal-header .btn-close {
    margin: 0;
  }

  .slider-modal-dialog-view .modal-header .btn-close {
    padding: 15px;
  }

  .slider-modal-dialog-edit .modal-header .btn-close {
    padding: 15px;
  }

  .modal-header .btn-close:focus {
    box-shadow: none;
  }

  .modal-header.change-brand-modal-header {
    padding: 30px 23px;
  }

  .modal-custom-backdrop {
    z-index: 1055;
  }

  .edit-brand-dialog {
    max-width: 582px;
  }

  input.form-control {
    height: 48px;
    width: 100%;
    margin: 0px 0px 10px 0px;
    border-color: var(--main-orange);
  }

  input.form-control.input-with-sign {
    border-left: none;
    padding-left: 0px;
  }

  input.form-control.input-gray {
    border-color: var(--gray-1);
    background-color: #FDFDFE;
  }
  input.form-control.input-gray:focus {
    border-color: var(--gray-5);
  }

  input.form-control:focus, textarea.form-control:focus {
    box-shadow: unset;
    border-color: var(--main-orange);
  }

  .input-group .input-sign {
    border: 1px solid var(--main-orange);
    border-right: none;
    height: 48px;
    background-color: var(--white);
  }

  .input-group .calendar-input-sign {
    border: 1px solid var(--gray-2);
    height: 48px;
    background-color: #FDFDFE;
  }

  input.form-control.datepicker-input {
    border-right: none;
  }
  input.form-control.datepicker-input:focus {
    border: 1px solid var(--gray-2);
    border-right: none;
  }

  label.form-label {
    color: var(--gray-6);
  }

  .news-item-textarea.form-control {
    height: 144px;
    resize: none;
  }

  .pricelist-textarea {
    height: 100px;
    margin-bottom: 10px;
    resize: none;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .home-form-datepicker-popper-start-date,
  .price-generator-form-datepicker-popper-date {
    position: absolute !important;
    left: unset !important;
    top: 100px !important;
    transform: unset !important;
  }

  .price-generator-form-datepicker-popper-date {
    top: 80px !important;
  }

  .price-generator-datepicker-column {
    position: relative;
  }

  .home-form-datepicker-popper-end-date {
    position: absolute !important;
    left: unset !important;
    top: 200px !important;
    transform: unset !important;
  }

  .scripts-page-datepicker-start-date,
  .scripts-page-datepicker-end-date,
  .stock-report-datepicker-start-date,
  .stock-report-datepicker-end-date
  {
    position: absolute !important;
    top: 80px !important;
    transform: unset !important;
  }

  .react-datepicker {
    border-radius: 0px 0px 10px 10px;
    border: 1px solid var(--gray-4);
  }

  .row {
    margin-left: 0;
    margin-right: 0;
  }

  form .row {
    margin-left: -10px;
    margin-right: -10px;
  }

  // bootstrap accordion styles
  .accordion .card {
    border: none;
  }

  .accordion .card .card-header {
    background-color: transparent;
    border-bottom: 1px solid var(--orange-3);
  }
`;

export default GlobalStyle;
